module.exports = __webpack_public_path__ + "font-awesome.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/font-awesome/font-awesome.woff2?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.woff2?v=4.7.0
// module chunks = 5